// src/utils/componentTester.js
// Utility to test that all components are working properly

export function testAllComponents() {
  console.log('🧪 Testing all components...')
  
  const results = {
    jquery: false,
    bootstrap: false,
    owlCarousel: false,
    customScripts: false
  }

  // Test jQuery
  try {
    if (typeof window.$ !== 'undefined' && typeof window.jQuery !== 'undefined') {
      if (typeof window.$.fn !== 'undefined') {
        results.jquery = true
        console.log('✅ jQuery: Working')
      } else {
        console.log('❌ jQuery: fn property missing')
      }
    } else {
      console.log('❌ jQuery: Not available')
    }
  } catch (error) {
    console.log('❌ jQuery: Error -', error.message)
  }

  // Test Bootstrap
  try {
    if (typeof window.bootstrap !== 'undefined') {
      if (typeof window.$.fn.carousel !== 'undefined' && 
          typeof window.$.fn.modal !== 'undefined') {
        results.bootstrap = true
        console.log('✅ Bootstrap: Working (JS + jQuery plugins)')
      } else {
        console.log('❌ Bootstrap: jQuery plugins missing')
      }
    } else {
      console.log('❌ Bootstrap: Not available')
    }
  } catch (error) {
    console.log('❌ Bootstrap: Error -', error.message)
  }

  // Test Owl Carousel
  try {
    if (typeof window.$.fn.owlCarousel !== 'undefined') {
      results.owlCarousel = true
      console.log('✅ Owl Carousel: Working')
    } else {
      console.log('❌ Owl Carousel: Not available')
    }
  } catch (error) {
    console.log('❌ Owl Carousel: Error -', error.message)
  }

  // Test custom scripts (check if DOM elements exist that scripts would create/modify)
  try {
    // This is a basic test - you can expand based on what your custom scripts do
    if (typeof window.$ !== 'undefined') {
      const testElements = ['#showAddedTax', '#ShowMorebtn', '#quickTopUp']
      const foundElements = testElements.filter(selector => window.$(selector).length > 0)
      
      if (foundElements.length > 0) {
        results.customScripts = true
        console.log('✅ Custom Scripts: Working (found elements:', foundElements.join(', '), ')')
      } else {
        console.log('⚠️ Custom Scripts: No test elements found (may be normal if not on relevant page)')
        results.customScripts = true // Assume working if no errors
      }
    }
  } catch (error) {
    console.log('❌ Custom Scripts: Error -', error.message)
  }

  // Summary
  const allWorking = Object.values(results).every(result => result === true)
  console.log('📊 Component Test Summary:', results)
  
  if (allWorking) {
    console.log('🎉 All components are working correctly!')
  } else {
    console.log('⚠️ Some components have issues. Check the logs above.')
  }

  return results
}

// Function to test Bootstrap components specifically
export function testBootstrapComponents() {
  console.log('🧪 Testing Bootstrap components...')
  
  if (typeof window.$ === 'undefined') {
    console.log('❌ jQuery not available for Bootstrap testing')
    return false
  }

  const tests = []

  // Test carousel
  try {
    if (typeof window.$.fn.carousel !== 'undefined') {
      tests.push({ name: 'Carousel', status: '✅' })
    } else {
      tests.push({ name: 'Carousel', status: '❌' })
    }
  } catch (error) {
    tests.push({ name: 'Carousel', status: '❌', error: error.message })
  }

  // Test modal
  try {
    if (typeof window.$.fn.modal !== 'undefined') {
      tests.push({ name: 'Modal', status: '✅' })
    } else {
      tests.push({ name: 'Modal', status: '❌' })
    }
  } catch (error) {
    tests.push({ name: 'Modal', status: '❌', error: error.message })
  }

  // Test collapse
  try {
    if (typeof window.$.fn.collapse !== 'undefined') {
      tests.push({ name: 'Collapse', status: '✅' })
    } else {
      tests.push({ name: 'Collapse', status: '❌' })
    }
  } catch (error) {
    tests.push({ name: 'Collapse', status: '❌', error: error.message })
  }

  console.log('Bootstrap Component Tests:', tests)
  return tests.every(test => test.status === '✅')
}

// Make functions available globally for browser console testing
if (typeof window !== 'undefined') {
  window.testAllComponents = testAllComponents
  window.testBootstrapComponents = testBootstrapComponents
}
